import type { ScrollGlobeFeatureItem } from "./scrollGlobe.types";

export type ScrollGlobeFeatureProps = ScrollGlobeFeatureItem;

/**
 * Una tarjeta de la lista de una sección: un punto, un título y una
 * frase. La usan tanto los beneficios (título = el beneficio) como las
 * comisiones (título = el porcentaje).
 *
 * ── Contraste ────────────────────────────────────────────────────────
 * El original pinta la descripción en `text-gray-500` (#6B7280). Sobre el
 * fondo crema de esta página eso se queda en 4.6:1 —pasa por los pelos, y
 * solo mientras el degradado esté en su parte más clara—, así que aquí va
 * en `ds-ink-3` (#3A2F55, ~10:1). El título sube igual de `gray-900` a
 * `ds-ink`.
 *
 * ── El levantamiento al pasar el ratón ───────────────────────────────
 * Se apaga con `motion-reduce`. Es un adorno de puntero: quitarlo no
 * quita ninguna información, y son cuatro o cinco tarjetas moviéndose una
 * tras otra según por dónde pase el ratón.
 */
export function ScrollGlobeFeature({ title, description }: ScrollGlobeFeatureProps) {
  return (
    <li className="group rounded-2xl border border-ds-border bg-white/60 p-4 text-left backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-ds-violet-pop/30 hover:bg-white hover:shadow-ds-card motion-reduce:transform-none motion-reduce:transition-none sm:p-5">
      <div className="flex items-start gap-3">
        <span
          aria-hidden="true"
          className="mt-2 h-2 w-2 shrink-0 rounded-full bg-ds-violet-pop/60 transition-colors group-hover:bg-ds-violet-pop"
        />
        <div className="min-w-0 flex-1 space-y-1">
          <h3 className="text-[16px] font-semibold text-ds-ink sm:text-[18px]">{title}</h3>
          <p className="text-[14px] leading-relaxed text-ds-ink-3 sm:text-[16px]">
            {description}
          </p>
        </div>
      </div>
    </li>
  );
}
